import formControlClasses from "@mui/material/FormControl/formControlClasses";
import inputLabelClasses from "@mui/material/InputLabel/inputLabelClasses";
import { textFieldLabelResponsive } from "../../styles/utils/textfield.module";
export const MuiInputLabelTheme = (dt) => {
    return {
        styleOverrides: {
            root: Object.assign(Object.assign({}, textFieldLabelResponsive(dt, ["inputLabel"])), { color: dt.color.onSurface.key, [`&.${inputLabelClasses.focused}`]: {
                    color: dt.color.onSurface.key,
                }, [`&.${inputLabelClasses.error}`]: {
                    color: dt.cta.outlined.color.text.signal.error.default,
                }, "&.MuiFormLabel-colorSuccess": {
                    color: dt.cta.outlined.color.text.signal.success.default,
                }, [`&.${inputLabelClasses.disabled}`]: {
                    color: dt.cta.outlined.color.text.primary.disabled,
                }, [`.${formControlClasses.root} > &`]: {
                    position: "static",
                    transform: "none",
                } }),
        },
    };
};
